import script from "./events.vue?vue&type=script&setup=true&lang=js"
export * from "./events.vue?vue&type=script&setup=true&lang=js"

import "./events.vue?vue&type=style&index=0&id=1bd8087c&lang=scss&scoped=true"
script.__scopeId = "data-v-1bd8087c"

export default script